import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';
import { INITIAL_LOCATIONS } from './constants';

const locationsSlice = createSlice({
  name: 'locations',
  initialState: { items: INITIAL_LOCATIONS },
  reducers: {
    addLocation(state, { payload }) {
      state.items.push({
        ...payload,
        id: payload.id ?? uuidv4(),
        active: true,
      });
    },
    updateLocation(state, { payload }) {
      const idx = state.items.findIndex((l) => l.id === payload.id);
      if (idx >= 0) state.items[idx] = { ...state.items[idx], ...payload };
    },
    deleteLocation(state, { payload: id }) {
      state.items = state.items.filter((l) => l.id !== id);
    },
  },
});

export const { addLocation, updateLocation, deleteLocation } =
  locationsSlice.actions;
export default locationsSlice.reducer;
